import React, {useEffect, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Form from 'react-bootstrap/Form'

import {Container, Content, Div} from './styles';

import Logo from "../../components/Logo";
import InputText from "../../components/InputText";
import ButtonConfirm from "../../components/ButtonConfirm";
import ButtonBack from "../../components/ButtonBack";

import {find} from "../../services/serviceFind";
import {contactInfo} from "../../services/serviceContactInfo";
import {sendCode} from "../../services/serviceSendCode";
import {validateCode} from "../../services/serviceValidateCode";
import {
    containerError,
    hideAllError,
    showError,
    showMessageError,
    showMessageSuccess
} from "../../services/serviceShowMessage";
import PasswordReset from "../PasswordReset";

interface HashParams {
    uriRedirect: string;
}

interface contactData {
    id: number,
    tipo_id: string,
    descricao: string,
}

const Home: React.FC = () => {

    const urlBase = process.env.REACT_APP_URL_BASE ? process.env.REACT_APP_URL_BASE : '';

    const {params} = useRouteMatch<HashParams>();

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);

    const uri = queryParams.get('redirect');

    const [uriRedirect, setUriRedirect] = useState('');

    const [loading, setLoading] = useState(false);

    const [showContact, setShowContact] = useState(false);
    const [showConfirmHash, setShowConfirmHash] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [showPassword, setShowPassword] = useState(false);

    const [formCpf, setFormCpf] = useState('');
    const [formContact, setFormContact] = useState('');
    const [formHash, setFormHash] = useState('');

    const [dataContact, setDataContact] = useState<contactData[]>([]);
    const [dataContactSend, setDataContactSend] = useState('');
    const [dataContactTipo, setDataContactTipo] = useState('');

    useEffect(() => {
        setUriRedirect('');

        if (params.uriRedirect) {
            setUriRedirect(params.uriRedirect);
        }

        if (uri !== null) {
            setUriRedirect(uri);
        }
    }, [params.uriRedirect, uri]);

    const onFind = async () => {
        setLoading(true);

        localStorage.setItem('@Unisuam/token', '');
        localStorage.setItem('@Unisuam/hash', '');

        localStorage.setItem('@Unisuam/uriRedirect', uriRedirect.replace(/_/g, '/'));

        await find(urlBase, formCpf, uriRedirect).then(items => {
            if (!items.success) {
                showError(items.error);
            } else {
                localStorage.setItem('@Unisuam/token', items.data.token);
            }

            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const onContactInfo = async (token: string) => {
        setLoading(true);

        localStorage.setItem('@Unisuam/hash', '');

        await contactInfo(urlBase, token).then(items => {
            if (!items.success) {
                showError(items.error);
            } else {
                setDataContact(items.data);

                hideAllError();

                setShowForm(false);
                setShowContact(true);
            }

            setLoading(false);

        }).catch(() => {
            setLoading(false);
        });
    };

    const onSendCode = async (reSendCode: undefined | boolean, token: string, id: number, tipoId: string) => {
        setLoading(true);

        localStorage.setItem('@Unisuam/hash', '');

        await sendCode(urlBase, token, id, tipoId).then(items => {
            if (!items.success) {
                showError(items.error);
            } else {
                hideAllError();

                if (reSendCode) {
                    showMessageSuccess('Código reenviado com sucesso', 0);
                }

                setShowContact(false);
                setShowConfirmHash(true);
            }

            setLoading(false);

        }).catch(() => {
            setLoading(false);
        });
    };

    const onValidateCode = async (token: string, hash: string) => {
        setLoading(true);

        localStorage.setItem('@Unisuam/hash', '');

        await validateCode(urlBase, token, hash).then(items => {
            if (!items.success) {
                showError(items.error);
            } else {
                localStorage.setItem('@Unisuam/hash', formHash);

                hideAllError();

                setShowConfirmHash(false);
                setShowPassword(true);
            }

            setLoading(false);

        }).catch(() => {
            setLoading(false);
        });
    };

    const onInit = async () => {

        if (!formCpf) {
            showMessageError('Por favor, insira seu CPF.', 10);

            return true;
        }

        hideAllError();

        await onFind();

        let token = localStorage.getItem('@Unisuam/token');

        if (typeof token === "string") {
            await onContactInfo(token);
        }
    };

    const confirmFormSendCode = async (reSendCode?: boolean) => {

        if (!formContact) {
            showMessageError('Por favor, selecione um contato.', 0);

            return false;
        }

        hideAllError();

        let res = formContact.split('|');

        let token = localStorage.getItem('@Unisuam/token');

        if (typeof token === "string") {
            await onSendCode(reSendCode, token, Number(res[0]), res[1]);
        }

        setDataContactSend(res[2]);
        setDataContactTipo(res[1]);

        console.log(dataContactTipo);
    };

    const confirmFormValidateCode = async () => {

        if (!formHash) {
            showMessageError('Por favor, insira o código.', 0);

            return false;
        }

        hideAllError();

        let token = localStorage.getItem('@Unisuam/token');

        if (typeof token === "string") {
            await onValidateCode(token, formHash);
        }
    };

    const backHome = () => {
        setShowForm(true);
        setShowContact(false);
    };

    const backContact = () => {
        setShowContact(true);
        setShowConfirmHash(false);
    };

    const handleCpfChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setFormCpf(event.target.value);
    };

    const handleHashChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setFormHash(event.target.value);
    };

    const handleContactChange = (event: { target: { id: React.SetStateAction<string>; }; }) => {
        setFormContact(event.target.id);
    };

    const onSubmitContact = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        onInit().then(() => {
        });
    };

    const onSubmitSendCode = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        confirmFormSendCode().then(() => {
        });
    };

    const onSubmitValidateCode = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        confirmFormValidateCode().then(() => {
        });
    };

    return (
        <Container>

            {containerError()}

            <Logo/>

            <Content show={showForm}>
                <h5>Primeiro, vamos localizar sua conta!</h5>
                <form onSubmit={onSubmitContact}>
                    <label htmlFor={'formCpf'}>Insira seu número de CPF*:</label>
                    <InputText placeholder={'CPF'}
                               type={'text'}
                               autoComplete={'false'}
                               name={'formCpf'}
                               id={'formCpf'}
                               onChange={handleCpfChange}
                               showDisabled={loading}
                    />
                    <ButtonConfirm type={'button'}
                                   onClick={() => onInit()}
                                   label={'Localizar'}
                                   showLoading={loading}
                    />
                </form>
            </Content>

            <Content show={showContact}>
                <h5>Selecione um contato</h5>
                <Container>Selecione um contato para receber o código de validação.</Container>
                <form onSubmit={onSubmitSendCode}>
                    <span>
                        <strong>Contato(s)*:</strong>
                    </span>
                    <br/>
                    <fieldset>
                        {
                            dataContact.map((value: contactData, index: number) => (
                                    <Form.Check
                                        key={index}
                                        onChange={handleContactChange}
                                        className="mb-3"
                                        type={'radio'}
                                        label={value.descricao}
                                        id={value.id + '|' + value.tipo_id + '|' + value.descricao}
                                        name='formContato'
                                        disabled={loading}
                                    />
                                )
                            )
                        }
                    </fieldset>
                    <ButtonConfirm type={'submit'}
                                   onClick={() => confirmFormSendCode()}
                                   label={'Confirmar'}
                                   showLoading={loading}
                    />
                    <ButtonBack type={'button'}
                                onClick={() => backHome()}
                                label={'Voltar'}
                                disabled={loading}
                    />
                </form>
            </Content>

            <Content show={showConfirmHash}>
                <h5>Enviamos um código de verificação para seu e-mail</h5>
                <Container>
                    Acabamos de enviar um código de verificação para seu e-mail <strong>{dataContactSend}</strong>. Se
                    não encontrar nosso e-mail na sua caixa de entrar. verifique a pasta de lixo eletrônico.
                </Container>
                <form onSubmit={onSubmitValidateCode}>
                    <label htmlFor={'formHash'}>Insira o código*:</label>
                    <InputText placeholder={'Código'}
                               type={'text'}
                               autoComplete={'false'}
                               name={'formHash'}
                               id={'formHash'}
                               onChange={handleHashChange}
                               showDisabled={loading}
                    />
                    <ButtonConfirm type={'button'}
                                   onClick={() => confirmFormValidateCode()}
                                   label={'Confirmar'}
                                   showLoading={loading}
                    />
                    <ButtonBack type={'button'}
                                onClick={() => backContact()}
                                label={'Voltar'}
                                disabled={loading}
                    />
                    <br/>
                    <Div show={!loading}>
                        Não recebeu o código?
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={() => confirmFormSendCode(true)}>
                            <strong className={'color'}> Enviar novamente</strong>
                        </a>
                    </Div>
                    <Div show={loading}>
                        Não recebeu o código? <strong>Enviar novamente</strong>
                    </Div>
                </form>
            </Content>

            <PasswordReset show={showPassword}/>

        </Container>
    );
};

export default Home;
